export enum AnimationName {
    SLIDE_UP = 'menuSlideUp',
    SLIDE_DOWN = 'menuSlideDown'
}
